import React from 'react';
import TemplatePage from '../../../components/templatePage';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from '../../../../../@casino/useRouter';
import { setGetUserById } from '../../store/thunk/setGetUserById';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Navigation from '../../components/navigation';
import FsModal from '../../../../desktop/users/components/fsModal';
import { setPostLiftingIssue } from '../../../../desktop/users/store/thunk/setPostLifting';
import Dialog from '@material-ui/core/Dialog';
import { setPostUpdateBalance } from '../../../../desktop/users/store/thunk/setPostUpdateBalance';
import { setPostAirUpdateBalance } from '../../../../desktop/users/store/thunk/setPostAirUpdateBalance';
import { setPostUpdateWager } from '../../../../desktop/users/store/thunk/setPostUpdateWager';
import clsx from 'clsx';
import { Allow as AllowMap } from '../../../../settings/allow';

const useStyles = makeStyles(() => ({
    root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        color: '#fff',
        fontFamily: 'Montserrat, sans-serif',
        fontSize: 18,
        borderBottom: '1px solid rgba(0,0,0,.3)',
        width: '100%',
        textAlign: 'center',
        paddingTop: 20,
        paddingBottom: 20
    },
    online: ({ online }) => ({
        position: 'absolute',
        top: 10,
        left: 10,
        fontSize: 14,
        color: online ? '#3cde0b' : 'red'
    }),
    group: {
        position: 'absolute',
        top: 10,
        right: 10,
        fontSize: 14,
        color: '#3cde0b',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgb(255, 255, 255, .3)',
        borderRadius: '4px',
        padding: '5px 10px',
        fontWeight: 700
    },
    wrapLogin: {
        margin: '12px 0'
    },
    wrapBlock: {
        padding: '0 20px',
        display: 'flex',
        justifyContent: 'space-between',
        columnGap: 5
    },
    w50: {
        width: '50%'
    },
    btnReset: {
        padding: '10px 15px',
        background: '#FF3156',
        borderRadius: 4,
        cursor: 'pointer',
        color: '#fff'
    },
    btn: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        marginBottom: 8
    },
    wrapLastLine: {
        display: 'flex',
        justifyContent:'space-around',
        padding: '0 20px'
    },
}))

const View = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const classes = useStyles();
    const [isShowNavigation, setIsShowNavigation] = React.useState(false);
    const { id } = router.query;
    const [showZeroBalance, setShowZeroBalance] = React.useState(false);
    const [showAirZeroBalance, setShowAirZeroBalance] = React.useState(false);
    const [showConfirmation, setShowConfirmation] = React.useState(false)

    React.useEffect(() => {
        dispatch(setGetUserById(id))
    }, [id])

    const view = useSelector(state => state.usersMobile.view);
    const viewAdmin = useSelector(state => state.auth.admin);

    const BlockItem = ({ title, amount }) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', marginBottom: 8 }}>
                <span style={{
                    color: 'hsla(0,0%,100%,.5)',
                    fontSize: '14px',
                    fontFamily: 'PT-sans, sans-serif',
                    paddingBottom: 4
                }}>{title}:</span>
                <span
                    style={{
                        color: '#fff',
                        fontSize: 14,
                        fontFamily: 'PT-sans, sans-serif',
                    }}
                >
                    {amount}
                </span>
            </div>
        )
    }

    const [lifting, setLifting] = React.useState(false);
    const [fs, setFs] = React.useState(false);
    const [amountLifting, setAmountLifting] = React.useState(0);
    const [maxBonus, setMaxBonus] = React.useState(0);
    const [wager, setWager] = React.useState(20);
    const Allow = AllowMap();


    return (
        <TemplatePage
            title={view.login}
        >
            <div style={{ width: 'calc(100% - 20px)', marginTop: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', columnGap: 10 }}>
                    <span
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%',
                            border: '1px solid #ffce01',
                            cursor: 'pointer',
                            outline: 'none',
                            padding: '5px 0',
                            background: '#ffce01',
                            borderRadius: '12px',
                            color: '#24263e',
                            fontSize: 14,
                            fontWeight: 700
                        }}
                        onClick={() => {
                            setIsShowNavigation(true)
                        }}
                    >Дополнительно</span>
                </div>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', margin: '12px 0' }}>
                        <span style={{
                            color: '#fff',
                            overflow: 'hidden',
                            fontSize: 14,
                            fontFamily: 'PT Sans,sans-serif',
                            lineHeight: '17px',
                            userSelect: 'none',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                        }}>Детализация по игроку</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px 0' }}>
                        <div className={classes.mr16}>
                            <span
                                style={{ padding: '10px 15px', background: '#FF3156', borderRadius: 4, cursor: 'pointer', color: '#fff' }}
                                onClick={() => setLifting(true)}
                            >Подъемные</span>
                        </div>
                        <div className={classes.mr16}>
                            <span
                                style={{ padding: '10px 15px', background: '#FF3156', borderRadius: 4, cursor: 'pointer', color: '#fff' }}
                                onClick={() => setFs(true)}
                            >Выдать FS</span>
                        </div>
                    </div>
                    <div className={classes.wrapBlock}>
                        <div className={classes.w50}>
                            <BlockItem title="Баланс" amount={new Intl.NumberFormat('ru-RU').format(view.balance ? view.balance.toFixed(2) : view.balance)} />
                            {
                                viewAdmin?.allow?.includes(Allow.ManagementBalance.allow) &&
                                <div className={classes.btn}>
                                    <span className={classes.btnReset}
                                        onClick={() => setShowZeroBalance(true)}
                                    >Обнулить
                                    </span>
                                </div>
                            }
                            <BlockItem title="Колличество депозитов" amount={new Intl.NumberFormat('ru-RU').format(+view.count_deposit ? (+view.count_deposit).toFixed(2) : +view.count_deposit)} />
                            <BlockItem title="Колличество выводов" amount={new Intl.NumberFormat('ru-RU').format(+view.withdrawals ? (+view.withdrawals).toFixed(2) : +view.withdrawals)} />
                            <BlockItem title="Колличество бонусов" amount={new Intl.NumberFormat('ru-RU').format(+view.count_bonuses ? (+view.count_bonuses).toFixed(2) : view.count_bonuses)} />
                            <BlockItem title="Колличество джекпотов" amount={new Intl.NumberFormat('ru-RU').format(+view.count_jackpot ? (+view.count_jackpot).toFixed(2) : +view.count_jackpot)} />
                            <BlockItem title="Сумма ставок" amount={new Intl.NumberFormat('ru-RU').format(view.sum_bet ? view.sum_bet.toFixed(2) : view.sum_bet)} />
                        </div>


                        <div style={{ width: '50%' }}>
                            <BlockItem title="Воздушный баланс" amount={new Intl.NumberFormat('ru-RU').format(view.air_balance ? view.air_balance.toFixed(2) : view.air_balance)} />
                            {
                                viewAdmin?.allow?.includes(Allow.ManagementBalance.allow) &&
                                <div className={classes.btn}>
                                    <span className={classes.btnReset}
                                        onClick={() => setShowAirZeroBalance(true)}
                                    >Обнулить
                                    </span>
                                </div>
                            }
                            <BlockItem title="Сумма депозитов" amount={new Intl.NumberFormat('ru-RU').format(view.sum_deposit ? view.sum_deposit.toFixed(2) : view.sum_deposit)} />
                            <BlockItem title="Сумма выводов" amount={new Intl.NumberFormat('ru-RU').format(view.sum_withdrawals ? view.sum_withdrawals.toFixed(2) : view.sum_withdrawals)} />
                            <BlockItem title="Сумма бонусов" amount={new Intl.NumberFormat('ru-RU').format(+view.sum_bonuses ? (+view.sum_bonuses).toFixed(2) : view.sum_bonuses)} />
                            <BlockItem title="Сумма джекпотов" amount={new Intl.NumberFormat('ru-RU').format(view.sum_jackpot ? view.sum_jackpot.toFixed(2) : view.sum_jackpot)} />
                            <BlockItem title="Сумма выигрышей" amount={new Intl.NumberFormat('ru-RU').format(view.sum_win ? view.sum_win.toFixed(2) : view.sum_win)} />
                        </div>
                    </div>
                    <div  className={classes.wrapLastLine}>
                        <div className={classes.w50}>
                            <BlockItem title="Последнее действие" amount="air" />
                        </div>
                        {
                            viewAdmin?.allow?.includes(Allow.ManagementBalance.allow) &&
                            <div className={clsx(classes.btn, classes.w50)}> 
                                <BlockItem title="Wager" amount={new Intl.NumberFormat('ru-RU').format(view.wager ? view.wager.toFixed(2) : view.wager)} />
                                <span className={classes.btnReset}
                                    onClick={() => setShowConfirmation(true)}
                                >Обнулить
                                </span>
                            </div>
                        }
                    </div>
                </div>
                <Navigation isShowNavigation={isShowNavigation} setIsShowNavigation={setIsShowNavigation} id={id} profile={view} />
            </div>
            <FsModal fs={fs} setFs={setFs} id={id} profile={view} />
            <Dialog onClose={() => {
                setLifting(false);
                setAmountLifting(0);
                setWager(20)
            }} open={lifting}>
                <div style={{ padding: 20 }}>
                    <label htmlFor="amountLifting">
                        <span className={classes.label} style={{ color: '#2F2F2F', fontSize: 16, textAlign: 'center' }}>Сумма подъемных</span>
                        <input
                            type="text"
                            style={{width: 'calc(100% - 20px)', padding: 10, outline: 'none', border: '1px solid #eee', marginTop: 12, marginBottom: 12, borderRadius: 4 }}
                            placeholder="Введите сумму"
                            id="amountLifting"
                            value={amountLifting}
                            onChange={(v) => {
                                if (!isNaN(+v.target.value)) {
                                    setAmountLifting(+v.target.value);
                                }
                            }}
                        />
                    </label>
                    <label htmlFor="wager">
                        <span className={classes.label} style={{ color: '#2F2F2F', fontSize: 16, textAlign: 'center' }}>Wager</span>
                        <div style={{position: 'relative'}}>
                            <span style={{color: '#acacac', position: 'absolute', top: 23, left: 10}}>x</span>
                            <input
                                type="text"
                                style={{width: 'calc(100% - 20px)', padding: '10px 10px 10px 17px', outline: 'none', border: '1px solid #eee', marginTop: 12, marginBottom: 12, borderRadius: 4 }}
                                placeholder="Введите сумму"
                                id="wager"
                                value={wager}
                                onChange={(v) => {
                                    if (!isNaN(+v.target.value)) {
                                        setWager(+v.target.value);
                                    }
                                }}
                            />
                        </div>
                    </label>
                    <label htmlFor="max_bonus">
                        <span className={classes.label} style={{ color: '#2F2F2F', fontSize: 16, textAlign: 'center' }}>Максимальная сумма бонуса</span>
                        <div style={{position: 'relative'}}>
                            <span style={{color: '#acacac', position: 'absolute', top: 23, left: 10}}>x</span>
                            <input
                                type="text"
                                style={{width: 'calc(100% - 20px)', padding: '10px 10px 10px 17px', outline: 'none', border: '1px solid #eee', marginTop: 12, marginBottom: 12, borderRadius: 4 }}
                                placeholder="Введите сумму"
                                id="max_bonus"
                                value={maxBonus}
                                onChange={(v) => {
                                    if (!isNaN(+v.target.value)) {
                                        setMaxBonus(+v.target.value);
                                    }
                                }}
                            />
                        </div>
                    </label>
                    
                    <label htmlFor="currency">
                        <span>Валюта</span>
                        <input
                            type="text"
                            style={{ width: 'calc(100% - 20px)', padding: 10, outline: 'none', border: '1px solid #eee', borderRadius: 4 }}
                            value={view.currency}
                            disabled={true}
                        />
                    </label>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: 12 }}>
                        <span
                            style={{ marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
                            onClick={() => {
                                if (amountLifting && wager && maxBonus) {
                                    const object = {
                                        id,
                                        amount: +amountLifting,
                                        wager: +wager,
                                        max_bonus: +maxBonus
                                    }
                                    dispatch(setPostLiftingIssue(object));
                                    setLifting(false);
                                    setAmountLifting(0);
                                    setWager(0)
                                }
                            }}
                        >Пополнить</span>
                        <span style={{ marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', border: '1px solid #fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
                            onClick={() => {
                                setLifting(false)
                                setAmountLifting(0)
                            }}>Отмена</span>
                    </div>
                </div>
            </Dialog>
            <Dialog onClose={() => setShowZeroBalance(false)} open={showZeroBalance}>
                <div style={{ padding: 20 }}>
                    <span className={classes.label} style={{ color: '#2F2F2F' }}>Вы точно хотите обнулить Баланс?</span>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: 12 }}>
                        <span style={{ marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
                            onClick={() => {
                                dispatch(setPostUpdateBalance({ id }));
                                setShowZeroBalance(false);
                            }}
                        >Да</span>
                        <span style={{ marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', border: '1px solid #fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
                            onClick={() => setShowZeroBalance(false)}>Отмена</span>
                    </div>
                </div>
            </Dialog>
            <Dialog onClose={() => setShowAirZeroBalance(false)} open={showAirZeroBalance}>
                <div style={{ padding: 20 }}>
                    <span className={classes.label} style={{ color: '#2F2F2F' }}>Вы точно хотите обнулить Воздушный Баланс?</span>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: 12 }}>
                        <span style={{ marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
                            onClick={() => {
                                dispatch(setPostAirUpdateBalance({
                                    user_id: id,
                                }));
                                setShowAirZeroBalance(false);
                            }}
                        >Да</span>
                        <span style={{ marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', border: '1px solid #fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
                            onClick={() => setShowAirZeroBalance(false)}>Отмена</span>
                    </div>
                </div>
            </Dialog>
            <Dialog onClose={() => setShowConfirmation(false)} open={showConfirmation}>
                <div style={{ padding: 20 }}>
                    <span className={classes.label} style={{ color: '#2F2F2F' }}>Вы точно хотите обнулить Wager?</span>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: 12 }}>
                        <span style={{ marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
                            onClick={() => {
                                dispatch(setPostUpdateWager({ id }));
                                setShowConfirmation(false);
                            }}
                        >Да</span>
                        <span style={{ marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', border: '1px solid #fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center' }} onClick={() =>
                            setShowConfirmation(false)}>Отмена</span>
                    </div>
                </div>
            </Dialog>
        </TemplatePage>
    )
}

export default View;